import React from 'react';
/** import third-party libraries in the section above, Sort Lines Ascending */

import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
/** import mui components in the section above, Sort Lines Ascending */

/**
 * Label + info icon when a saved schedule email is not in the current org's user list.
 * Shown when id and name are null (email selected but not returned by the API).
 *
 * @returns {React.ReactElement}
 */
function NotFoundRecipientLabel() {
    return (
        <Tooltip
            title={
                <Typography variant="body1" component="span">
                    We couldn't find this email among your organization's users. They may not
                    receive scheduled reports.
                </Typography>
            }
        >
            <Box component="span" className="reports-recipients-selector__not-found-label">
                User not found
                <InfoOutlinedIcon fontSize="small" />
            </Box>
        </Tooltip>
    );
}

export default NotFoundRecipientLabel;
